module.exports = __webpack_public_path__ + "static/media/Lesson-4-10-Let-Us-be-of-One-Spirit.adc2c051.pdf";